<template>
  <v-card class="deposit-form pa-5" :color="$vuetify.theme.dark ? '#172233' : '#e8f1f8'">
    <v-row>
      <v-col cols="12">
        <v-card-title class="px-0 pt-0">Change Setting</v-card-title>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12" md="12" class="mb-3">
        <fieldset>
          <legend>Min. Trade Duration (min)</legend>
          <v-text-field :disabled="$canRoute('rms-settings') !== 1" type="number" v-model="form.min_trade_duration" label="Write Here" single-line solo hide-details
            class="custom-select"></v-text-field>
        </fieldset>
      </v-col>
      <v-col cols="12" sm="12" md="12" class="mb-3">
        <fieldset>
          <legend>
            <i class="fa fa-lastfm-square" aria-hidden="true"></i> Min. Margin
            Level
          </legend>
          <v-text-field :disabled="$canRoute('rms-settings') !== 1" type="number" v-model="form.min_margin_level" label="Write Here" single-line solo hide-details
            class="custom-select"></v-text-field>
        </fieldset>
      </v-col>
      <v-col cols="12" sm="12" md="12" class="mb-3">
        <fieldset>
          <legend>Max. Margin Level</legend>
          <v-text-field :disabled="$canRoute('rms-settings') !== 1" type="number" v-model="form.max_margin_level" label="Write Here " single-line solo hide-details
            class="custom-select"></v-text-field>
        </fieldset>
      </v-col>
      <v-col cols="12" sm="12" md="12" class="mb-3">
        <fieldset>
          <legend>Floating Profit (%)</legend>
          <v-text-field :disabled="$canRoute('rms-settings') !== 1" type="number" v-model="form.floating_profit_percentage" label="Write Here " single-line solo
            hide-details class="custom-select"></v-text-field>
        </fieldset>
      </v-col>
      <v-col cols="12" sm="12" md="12" class="mb-3">
        <fieldset>
          <legend>Credit Out (%)</legend>
          <v-text-field :disabled="$canRoute('rms-settings') !== 1" type="number" v-model="form.credit_out_percentage" label="Write Here " single-line solo
            hide-details class="custom-select"></v-text-field>
        </fieldset>
      </v-col>
       <v-col cols="12" sm="12" md="12" class="mb-3">
        <fieldset>
          <legend>Low Balance Threshold</legend>
          <v-text-field :disabled="$canRoute('rms-settings') !== 1" type="number" v-model="form.low_balance_threshold" label="Write Here " single-line solo
            hide-details class="custom-select"></v-text-field>
        </fieldset>
      </v-col>
      <v-col cols="12" sm="12" md="12" class="mb-3">
        <fieldset>
          <legend>Trading Idle Days</legend>
          <v-text-field :disabled="$canRoute('rms-settings') !== 1" type="number" v-model="form.trading_idle_days" label="Write Here " single-line solo
            hide-details class="custom-select"></v-text-field>
        </fieldset>
      </v-col>

      <v-col cols="12" sm="12" md="12" v-if="$canRoute('rms-settings') === 1">
        <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0" @click="updateSettings">
          Update
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { RMSSETTINGS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      form: {
        min_trade_duration: null,
        min_margin_level: null,
        max_margin_level: null,
        floating_profit_percentage: null,
        credit_out_percentage: null,
        low_balance_threshold: null,
        trading_idle_days: null,
      },
    };
  },

  computed: {
    ...mapState("admins", ["loggedAdmin"])
  },
  
  methods: {
    ...mapActions("rmssettings", [RMSSETTINGS__ACTIONS.UPDATERMSSETTINGS]),

    updateSettings() {
      const formData = Object.entries(this.form)
        .filter(([_, value]) => value !== null && value !== undefined)
        .reduce((obj, [key, value]) => {
          obj[key] = value;
          return obj;
        }, {});

      this[RMSSETTINGS__ACTIONS.UPDATERMSSETTINGS](formData);
      this.form.min_trade_duration = null;
      this.form.min_margin_level = null;
      this.form.max_margin_level = null;
      this.form.floating_profit_percentage = null;
      this.form.credit_out_percentage = null;
      this.form.low_balance_threshold = null;
      this.form.trading_idle_days = null;
    },
  },
};
</script>
